import tmhRequest from '@/config/tmhRequest'

export default {
    searchLimit: function (data) {
        return tmhRequest({
            url: '/customer/tmh/limit/searchlimit',
            method: 'post',
            params: data,
        })
    },
    searchLimitCount: function (data) {
        return tmhRequest({
            url: '/customer/tmh/limit/searchlimitcount',
            method: 'post',
            data: data,
        })
    },
    searchLimitByPage: function (data) {
        return tmhRequest({
            url: '/customer/tmh/limit/searchlimitbypage',
            method: 'post',
            data: data,
        })
    },
    addLimit: function (data) {
        return tmhRequest({
            url: '/customer/tmh/limit/addlimit',
            method: 'post',
            data: data,
        })
    },
    editLimit: function (data) {
        return tmhRequest({
            url: '/customer/tmh/limit/editlimit',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/customer/limit.js